export default {

  Title: 'Αναφορές'

}
